export const validatePricingAndFee = (formData = {}) => {
    const errors = [];
    const { rentalType, bookingType } = formData;
  
    if (
      rentalType === "Entire Place" &&
      (bookingType === "Hot bed" || bookingType === "Flexible")
    ) {
      if (!formData.perNightPrice || formData.perNightPrice <= 0) {
        errors.push({
          error: "Per Night Price is required and must be greater than 0",
          errorType: "pricing",
          field: "perNightPrice"
        });
      }
      if (formData.perNightPrice && !Number.isInteger(Number(formData.perNightPrice))) {
        errors.push({
          error: "Per Night Price must be a whole number",
          errorType: "pricing",
          field: "perNightPrice"
        });
      }
    }
  
    if (
      rentalType === "Entire Place" &&
      (bookingType === "Cold bed" || bookingType === "Flexible")
    ) {
      if (!formData.perMonthPrice || formData.perMonthPrice <= 0) {
        errors.push({
          error: "Per Month Price is required and must be greater than 0",
          errorType: "pricing",
          field: "perMonthPrice"
        });
      }
      if (formData.perMonthPrice && !Number.isInteger(Number(formData.perMonthPrice))) {
        errors.push({
          error: "Per Month Price must be a whole number",
          errorType: "pricing",
          field: "perMonthPrice"
        });
      }
    }
  
    if (rentalType === "Entire Place") {
      if (!formData.extraChargePerGuest || formData.extraChargePerGuest <= 0) {
        errors.push({
          error: "Extra Charge Per Guest is required and must be greater than 0",
          errorType: "pricing",
          field: "extraChargePerGuest"
        });
      }
      if (formData.extraChargePerGuest && !Number.isInteger(Number(formData.extraChargePerGuest))) {
        errors.push({
          error: "Extra Charge Per Guest must be a whole number",
          errorType: "pricing",
          field: "extraChargePerGuest"
        });
      }
    }
  
    if (formData.cleaningFee === "" || formData.cleaningFee === null || formData.cleaningFee === undefined) {
      errors.push({
        error: "Cleaning Fee is required",
        errorType: "fees",
        field: "cleaningFee"
      });
    }
    if (formData.cleaningFee !== "" && formData.cleaningFee !== null && formData.cleaningFee !== undefined) {
      if (formData.cleaningFee < 0) {
        errors.push({
          error: "Cleaning Fee cannot be negative",
          errorType: "fees",
          field: "cleaningFee"
        });
      }
      if (!Number.isInteger(Number(formData.cleaningFee))) {
        errors.push({
          error: "Cleaning Fee must be a whole number",
          errorType: "fees",
          field: "cleaningFee"
        });
      }
    }
  
    if (!formData.securityDeposite || formData.securityDeposite <= 0) {
      errors.push({
        error: "Security Deposit is required and must be greater than 0",
        errorType: "fees",
        field: "securityDeposite"
      });
    }
    if (formData.securityDeposite && !Number.isInteger(Number(formData.securityDeposite))) {
      errors.push({
        error: "Security Deposit must be a whole number",
        errorType: "fees",
        field: "securityDeposite"
      });
    }
  
    if (bookingType && (bookingType === "Cold bed" || bookingType === "Flexible")) {
      if (!formData.lineholderDiscountType) {
        errors.push({
          error: "Lineholder Discount Type is required",
          errorType: "discount",
          field: "lineholderDiscountType"
        });
      }
  
      if (
        formData.lineholderDiscountType === "Percentage" ||
        formData.lineholderDiscountType === "Fixed"
      ) {
        if (formData.lineholderDiscount === "" || formData.lineholderDiscount === null || formData.lineholderDiscount === undefined || formData.lineholderDiscount < 0) {
          errors.push({
            error: "Lineholder Discount is required and must be greater than or equal to 0",
            errorType: "discount",
            field: "lineholderDiscount"
          });
        }
  
        if (formData.lineholderDiscount !== "" && formData.lineholderDiscount !== null && formData.lineholderDiscount !== undefined) {
          if (!Number.isInteger(Number(formData.lineholderDiscount))) {
            errors.push({
              error: "Lineholder Discount must be a whole number",
              errorType: "discount",
              field: "lineholderDiscount"
            });
        }
      }
    }
    };
    return {
      isValid: errors.length === 0,
      errors: errors,
    }
  };